import { LinkSvg } from "icons/infograph";
import useTranslation from "next-translate/useTranslation";
import { Edu, Title, EduRow, EduItm } from "./Common.styled";

function Education() {
  const { t } = useTranslation("common");

  return (
    <Edu>
      <Title>{t("resume.education")}</Title>

      <EduRow>
        <EduItm>
          <h4>{t("resume.primary-title")}</h4>
          <a href="https://nps.edu.np/" target={"_blank"}>
            <LinkSvg /> Nepal Police School
          </a>
          <span>{t("resume.primary-duration")}</span>
          <p>{t("resume.primary-desc")}</p>
        </EduItm>
        <EduItm>
          <h4>{t("resume.high-title")}</h4>
          <a href="https://nps.edu.np/" target={"_blank"}>
            <LinkSvg /> Nepal Police School
          </a>
          <span>{t("resume.high-duration")}</span>
          <p>{t("resume.high-desc")}</p>
        </EduItm>
        <EduItm>
          <h4>{t("resume.college-title")}</h4>
          <a href="https://sonahangrai.com.np/resume#!" target={"_blank"}>
            <LinkSvg /> Purbanchal University
          </a>
          <span>{t("resume.college-duration")}</span>
          <p>{t("resume.college-desc")}</p>
        </EduItm>
      </EduRow>
    </Edu>
  );
}

export default Education;
